export enum MapPages {
  ESTATE_MAP = "EstateMap",
  STAGE_MAP = "StageMap",
  STAGE_LIST = "StageList",
}
